<mat-nav-list>
  <ng-container *ngTemplateOutlet="menuItemsTemplate; context: { $implicit: user }"></ng-container>
</mat-nav-list>

<div class="actions mt-3">
  <ng-content select="[xAction]"></ng-content>
</div>

<ng-template #menuItemsTemplate let-user>
  <ng-container *ngFor="let item of menuItems">
    <mat-list-item *ngIf="!item.condition || item.condition()">
      <a
        [routerLink]="getRouterLink(item)"
        routerLinkActive="is-active"
        (click)="handleItemClick(item)"
      >
        <fa-icon class="menu-icon" [icon]="item.icon"></fa-icon>

        <!-- Special case for profile in mobile mode -->
        <ng-container *ngIf="user && item.path === '/my-account/profile'; else ELSE">
          {{ user.firstName }}
        </ng-container>

        <ng-template #ELSE>{{ item.label }}</ng-template>
      </a>
    </mat-list-item>
  </ng-container>
</ng-template>
